<template>
  <button
    type="button"
    :class="{
      'active:outline-none focus:outline-none transition-colors duration-150': true,
      'text-[#F95E16] font-medium': active,
      'text-[#626262] hover:text-[#222222]': !active,
    }"
    @click.prevent.stop="$emit('click')"
  >{{ label }}</button>
</template>

<script>
/**
 * Component untuk menampilkan item toggle pada TBFCardToggle
 */
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
